export default "__VITE_ASSET__foBaEHk8__"